/* eslint-disable */ import { assertBoolean, assertString, attributeSwitchComponent, memoEval, textValueComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const recipeComponents = [
    attachAdminComponent.withComponent(textValueComponent, 'name', true).withEntity('Recipe').attach(memoEval((self)=>[
            self.name
        ], (name)=>({
            value: name
        })), (state)=>{
        assertString(state.value);
        return {
            name: state.value
        };
    }),
    attachAdminComponent.withComponent(textValueComponent, 'description', true).withEntity('Recipe').attach(memoEval((self)=>[
            self.description
        ], (description)=>({
            value: description
        })), (state)=>{
        assertString(state.value);
        return {
            description: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'visible', true).withEntity('Recipe').attach(memoEval((self)=>[
            self.visible
        ], (visible)=>({
            value: visible
        })), (state)=>{
        assertBoolean(state.value);
        return {
            visible: state.value
        };
    })
];

//# sourceMappingURL=recipe.js.map